import React, { useCallback, useContext, useRef, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button, Input } from 'ncoded-component-library';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import api from 'api';
import { User } from '../../../../../../../../../../../models/User';
import { Link } from 'react-router-dom';
import { getEditUserRoute, renderFullUserInfo } from 'utils';
import NoUsersFound from '../NoUsersFound';

import './SearchUser.styles.scss';

const LIMIT = '20';

type SearchUserProps = {
  className?: string;
};

const SearchUser: React.FC<SearchUserProps> = (props) => {
  const { className } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useState('');
  const [users, setUsers] = useState<User[]>([]);

  const hasFetched = useRef(false);

  const { popServerError } = useContext(PopNotificationsContext);

  const { t } = useTranslation();

  const classes = classNames('search-user', className);

  const onSearch = useCallback(async () => {
    setIsLoading(true);
    try {
      const {
        data: { items },
      } = await api.portfolio.admin.getAllUsers({
        $searchString: value,
        $limit: LIMIT,
      });
      setUsers(items);
      hasFetched.current = true;
    } catch (err) {
      popServerError(err);
    } finally {
      setIsLoading(false);
    }
  }, [value, popServerError]);

  return (
    <div className={classes}>
      <p className="search-user__title">{t('manageUserProfile')}</p>
      <p className="search-user__description">
        {t('manageUserProfileDescription')}
      </p>

      <div className="search-user__search">
        <Input value={value} onChange={(e) => setValue(e.target.value)} />
        <Button disabled={isLoading || !value} onClick={onSearch}>
          {t('search')}
        </Button>
      </div>

      <div className="search-user__list">
        {hasFetched.current && !users.length && !isLoading && <NoUsersFound />}

        {!isLoading &&
          users.map((user) => (
            <Link key={user._id} to={getEditUserRoute(user._id)}>
              {renderFullUserInfo(user)}
            </Link>
          ))}
      </div>
    </div>
  );
};

export default SearchUser;
